import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux"
import { PersistGate } from 'redux-persist/integration/react'
import { configStore, persistor } from './redux'
//import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'
import Loading from './Pages/Loading'
const App = React.lazy(() => {
  return Promise.all([
    import("./App"),
    new Promise(resolve => setTimeout(resolve, 1000))
  ])
    .then(([moduleExports]) => moduleExports);
});
ReactDOM.render(
  <Provider store={configStore()}>
    <PersistGate loading={<Loading />} persistor={persistor}>
      <Suspense fallback={<Loading />}>
      <App />
      </Suspense>
    </PersistGate>

  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
